// extracted by mini-css-extract-plugin
export var brand = "brandOutcomeCard-module--brand--a01e8";
export var description = "brandOutcomeCard-module--description--0c8c9";
export var homeDescription = "brandOutcomeCard-module--homeDescription--83146";
export var homeTitle = "brandOutcomeCard-module--homeTitle--9e160";
export var paper = "brandOutcomeCard-module--paper--904d6";
export var title = "brandOutcomeCard-module--title--4129d";